module.exports = __webpack_public_path__ + "img/707250c7513cdc13b7ee5e4d9691563f.png";